export const BackIcon = () => {
    return (
        <svg
            width="12"
            height="15"
            viewBox="0 0 12 15"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path d="M3.5 4H11V14H0" stroke="currentColor" strokeWidth="2" />
            <path
                d="M-1.31134e-07 3.66668L4.5 0.49125L4.5 6.8421L-1.31134e-07 3.66668Z"
                fill="currentColor"
            />
        </svg>
    );
};
